export const saveDraftToCache = (state, setState) => {
  const { title, author, content, slug, excerpt, cacheKey, images } = state;

  const updatedAt = new Date().toISOString();
  const draftData = {
    title,
    author,
    content,
    slug,
    excerpt,
    updatedAt,
    photos: images,
  };

  try {
    let key = cacheKey;
    if (!key) {
      key = `cachedDraft_${Date.now()}`;
      setState({ cacheKey: key }); // Update state with key
    }

    localStorage.setItem(key, JSON.stringify(draftData));
    setState({ updatedAt });
  } catch (error) {
    console.error("Failed to save draft to cache:", error);
  }
};

export const resetInactivityTimer = (currentTimeoutId, setNewTimeout) => {
  if (currentTimeoutId) {
    clearTimeout(currentTimeoutId);
  }

  const timeoutId = setTimeout(() => {
    setNewTimeout(); // this will trigger saveDraftToCache from your component
  }, 5000);

  return timeoutId;
};
